import { io } from "socket.io-client";
import A from "./ActionCreators";
import { post } from "./io";
import { getGlobalObject } from './versionConfig';
export default function initSocket(args) {
  //debugger;
  return (dispatch, getState) => {
    function doSetup() {
      let {
        websocketTarget,
        windowSessionId,
        agentId,
        personId,
        websocketArgs = {},
      } = args;

      let socket = new Promise((res, rej) => {
        if (websocketTarget) {
          let socket = io(websocketTarget, {
            timeout: 100,
            ...websocketArgs,
          });

          //console.log(socket);

          //socket.on("receiveThreadUpdateNotification", (data) => {
          //  dispatch(A.receivedThreadUpdateNotification(data));
          //});
          socket.on('receiveMessage', data => {
            const { message } = data;
            console.log('$recv', data);
            dispatch(A.receiveMessage({ newMessages: [ message ] }));
          });

          socket.on("reconnect", (attempt) => {
            console.log("RECONNECT");
          });

          socket.on("reconnect_attempt", (attempt) => {
            console.log("RECONNECT ATTEMPT!");
          });

          socket.on("connect_error", (err) => {
            console.log("connect_error!");
            //websocketArgs &&
            //  websocketArgs.connect_error &&
            //  websocketArgs.connect_error(err, res, rej);
            rej(err);
          });

          socket.on("reconnect_failed", () => {
            console.log("RECONNECT FAILED!");
          });

          socket.on("connect", () => {
            let postArgs = {
              route: "/registerWebsocket",
              body: {
                //NO PERSON ID, THEY NEED TO BE LOGGED IN
                //ALREADY...

                //personId:(personId||agentId),
                sid: socket.id,
              },
              state: getState(),
              onSuccess: () => {
                res(socket);
              },
              onServerFailure: () => {
                rej("Error starting socket.");
              },
              onInternetFailure: () => {
                rej("Internat failure?.");
              },
              dispatch: dispatch,
            };
            post(postArgs, dispatch);
          });

          socket.on("receiveTypingNotification", (data) => {
            debugger;
            dispatch(A.receiveTypingNotification(data));
          });

          /*
        socket.on('subscriptionEventUpdate',data => {
          dispatch(A.updateSubscriptionInfo(data));
        })
        */

          socket.on("ping", (data) => {
            let state = getState();
            let username = state.loginInfo.username;

            let postArgs = {
              route: "/pong",
              body: {
                ...data,
                sid: socket.id,
                windowSessionId,
                username,
              },
              state: getState(),
              onSuccess: () => {},
              onServerFailure: () => {},
              onInternetFailure: () => {},
              dispatch: dispatch,
            };
            post(postArgs, dispatch);
          });

          socket.on("connect", (data) => {
            res(socket);
          });

          window.addEventListener('beforeunload',() => {
            socket && socket.disconnect();
          });
        } else {
          res({
            disconnect: () => {},
          });
        }
      }).then(socket => {
        dispatch(A.fetchChatHistory());
        getGlobalObject().__refreshSocket = () => {
          socket.disconnect();
          doSetup();
        };
      }).catch(err => {
        getGlobalObject().__refreshSocket = () => {
          doSetup();
        };
      });
    }
    getGlobalObject().__refreshSocket = () => {
      doSetup();
    };
    doSetup();
  };
}
